import React from 'react'

const FinancialSettingsPage = () => {
  return (
    <div>
      <p>bbkjnkjn</p>
    </div>
  )
}

export default FinancialSettingsPage
